import React from 'react';
import { IArea } from "types/map";

export const MapContext = React.createContext({
  isGateStoryletModalOpen: false,
  onRequestOpenGateStoryletModal: (_: IArea) => {
  },
  onRequestCloseGateStoryletModal: () => {},
});

MapContext.displayName = 'MapContext';

export default MapContext;